module.exports = __webpack_public_path__ + "img/productVibration_3.e02a31a6.png";